import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.js";import{__require as o}from"../node_modules/highcharts/highcharts.js";var s=r(o());export{s as default};
//# sourceMappingURL=highcharts.js.map
